export default (that) => [
  {
    text: () => that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: () => that.$l('menu_text_approved') || '审核通过',
    icon: 'el-icon-check',
    menuType: 'approved',
    divided: true,
    allow: 'A',
  },
  {
    text: () => that.$l('menu_text_reject') || '审核驳回',
    icon: 'el-icon-close',
    menuType: 'reject',
    allow: 'R',
  },
]
